import { Flex, FormControl, Image, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../components/ButtonCmp'
import { WhiteContainer } from '../../components/WhiteContainer'
import { Body } from '../Layouts/Body'
import { BoxMensagem } from './Components/BoxMensagem'
import { useState, useEffect } from 'react'
import { appApi } from '../../services/appApi'
import { ModalChamadoRh } from '../Colaborador/Perfil/Components/ModalChamadoRh'
import { SelectCmp } from '../../components/SelectCmp'

interface Chamado {
  id: string
  dataCriacao: string
  texto: string
  status: number
  atualizacoes: Atualizacao[]
  colaborador: Colaborador
}

interface iModel {
  responsavel: boolean
  chamados: Chamado[]
}

interface Atualizacao {
  colaborador: Colaborador
  resposta: string
  dataCriacao: string
  rh: true
}

interface Colaborador {
  id: string
  nome: string
  avatar: string
  nomeCargo: string
}

export const ChamadoRh: React.FC = () => {
  const toast = useToast()
  const [ModalChamadoIsOpen, setModalChamadoIsOpen] = useState(false)
  const [Model, setModel] = useState<iModel>({
    chamados: [],
    responsavel: false
  })
  const [Status, setStatus] = useState('')
  const [resetarModal, setResetarModal] = useState(0)

  function getChamados(): void {
    appApi.get('Chamado')
      .then(res => {
        if (res.status === 200) {
          setModel(res.data)
        }
      })
      .catch(err => console.log(err))
  }

  function PostChamado(texto: string): void {
    const form = {
      texto: texto
    }
    appApi.post('Chamado', form)
      .then(res => {
        setModalChamadoIsOpen(false)
        setResetarModal(prev => prev + 1)
        getChamados()
        toast({
          title: 'Chamado enviado com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      }
      ).catch(err => console.log(err))
  }

  // function FilterBy(tipo: string): void {
  //   const arr = [...Model.chamados]

  //   if (tipo === '0') {
  //     arr.sort(function (a, b) {
  //       return new Date(converterData(b.dataCriacao)) > new Date(converterData(a.dataCriacao)) ? 1 : -1
  //     })
  //   } else if (tipo === '1') {
  //     console.log('Aqui')
  //     arr.sort(function (a, b) {
  //       return new Date(converterData(b.dataCriacao)) > new Date(converterData(a.dataCriacao)) ? 1 : -1
  //     })
  //     arr.reverse()
  //   }
  //   console.log()
  //   setModel({ ...Model, chamados: arr })
  // }

  // function converterData(val: string): Date {
  //   const [day, month, year] = val.split('/')
  //   const date = new Date(+year, +month - 1, +day)
  //   return date
  // }

  useEffect(() => {
    getChamados()
  }, [])
  return (
    <Body>
      {/* Preciso adicionar funcionalidade pra quando o chamado for enviado ao Rh, excluir a mensagem breve do modal */}
      <ModalChamadoRh
        key={resetarModal}
        isOpen={ModalChamadoIsOpen}
        onConfirm={PostChamado}
        onRequestClose={() => setModalChamadoIsOpen(false)}
      />
      <WhiteContainer>
        <Flex justifyContent={'space-between'}>
          <h1>Histórico</h1>
            <ButtonCmp
              onClick={() => setModalChamadoIsOpen(true)}
              VarColor='Green2'
            >Abrir chamado com RH</ButtonCmp>
        </Flex>
        <Flex marginTop={'1rem'} gap={'1rem'}>
              {/* <FormControl width={'30%'} >
                <FormLabel fontSize={'xl'} color={'var(--Gray1)'}>Ordenação</FormLabel>
                <SelectCmp borderColor={'var(--Gray4)'} size='md' onChange={(e) => { FilterBy(e.target.value) }}>
                  <option value={'0'}>Mais recente</option>
                  <option value={'1'}>Mais antigo</option>
                </SelectCmp>
              </FormControl> */}

              <FormControl width={'30%'} >
                <SelectCmp title='Status' OnChange={(e) => setStatus(e)}>
                  <option value={''}>Nenhum</option>
                  <option value={'0'}>Em andamento</option>
                  <option value={'1'}>Finalizado</option>
                </SelectCmp>
              </FormControl>
        </Flex>
        {
          (Model && Model?.chamados.length > 0) && (
            <Flex marginTop={'1rem'} flexDir={'column'} gap='1rem'>
              {
                Model?.chamados.filter(e => (e.status === parseInt(Status)) || Status === '').map((e, i) => {
                  return (
                    <BoxMensagem
                      reload={getChamados}
                      responsavel={Model.responsavel}
                      chamado={e}
                      key={i}
                    />
                  )
                })
              }
            </Flex>
          )
        }

        {
          (Model && Model?.chamados.length === 0) && (
            <Flex alignItems={'center'} color={'var(--Azul)'} justifyContent={'center'}>
              <Image className='sah_Img' height={'20rem'} src='https://sigah.blob.core.windows.net/onboard/bbb6990f-d313-488a-af99-5383c9bd1c82.png' />
              <h3>Ainda não há chamados cadastrados</h3>
            </Flex>
          )
        }
      </WhiteContainer>
    </Body>
  )
}
